export function sanitizeCnpj(value: string): string {
  return value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 14);
}

export function formatCnpj(value: string): string {
  const clean = sanitizeCnpj(value);

  if (clean.length <= 2) return clean;
  if (clean.length <= 5) return `${clean.slice(0, 2)}.${clean.slice(2)}`;
  if (clean.length <= 8) return `${clean.slice(0, 2)}.${clean.slice(2, 5)}.${clean.slice(5)}`;
  if (clean.length <= 12) {
    return `${clean.slice(0, 2)}.${clean.slice(2, 5)}.${clean.slice(5, 8)}/${clean.slice(8)}`;
  }

  return `${clean.slice(0, 2)}.${clean.slice(2, 5)}.${clean.slice(5, 8)}/${clean.slice(8, 12)}-${clean.slice(12)}`;
}

function calculateDigit(base: string, weights: number[]): number {
  const sum = base
    .split("")
    .reduce((accumulator, digit, index) => accumulator + Number(digit) * (weights[index] ?? 0), 0);
  const remainder = sum % 11;
  return remainder < 2 ? 0 : 11 - remainder;
}

export function isValidNumericCnpj(value: string): boolean {
  const clean = sanitizeCnpj(value);
  if (!/^\d{14}$/.test(clean)) return false;
  if (/^(\d)\1{13}$/.test(clean)) return false;

  const firstDigit = calculateDigit(clean.slice(0, 12), [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
  const secondDigit = calculateDigit(`${clean.slice(0, 12)}${firstDigit}`, [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);

  return clean === `${clean.slice(0, 12)}${firstDigit}${secondDigit}`;
}

export function validateCnpj(value: string): { valid: boolean; message?: string } {
  const clean = sanitizeCnpj(value);

  if (clean.length !== 14) {
    return { valid: false, message: "Digite os 14 caracteres do CNPJ." };
  }

  if (/^\d{14}$/.test(clean)) {
    return isValidNumericCnpj(clean)
      ? { valid: true }
      : { valid: false, message: "O CNPJ informado não passou na validação dos dígitos." };
  }

  if (!/^[A-Z0-9]{12}\d{2}$/.test(clean)) {
    return {
      valid: false,
      message: "No formato alfanumérico, os 12 primeiros caracteres podem conter letras e números e os 2 últimos devem ser dígitos.",
    };
  }

  return { valid: true };
}
